// ProEpoxy Product Data and Constants

export const BRAND = {
  name: 'ProEpoxy',
  fullName: 'Ox Resin ProEpoxy',
  tagline: 'Epoxy Flooring Systems',
  primaryColor: '#7A0B7A',
  secondaryColor: '#300033',
  logo: 'https://customer-assets.emergentagent.com/job_76625416-d43e-411a-b4d0-3b73c58f517c/artifacts/pv5hfhf0_IMG_8292.jpeg'
};

// System types
export const SYSTEMS = [
  { id: 'metallic', name: 'Metallic Epoxy', description: 'Stunning metallic floor finishes', available: true },
  { id: 'high_build', name: "Industrial 'High Build' Epoxy / Flake Systems", description: 'Heavy-duty industrial & decorative flake flooring', available: true }
];

// Products for Metallic Epoxy - Step 1: Floor Preparation
export const FLOOR_PREP_PRODUCTS = {
  smoothing_compounds: [
    { id: 'proflow_rapid', name: 'ProFlow Rapid', type: 'Latex', price: 20.35, unit: 'bag' },
    { id: 'proflow_smooth', name: 'ProFlow Smooth', type: 'Latex', price: 17.29, unit: 'bag' },
    { id: 'proflow_trade', name: 'ProFlow Trade', type: 'Latex', price: 12.99, unit: 'bag' },
    { id: 'proflow_finish', name: 'ProFlow Finish', type: 'Water', price: 14.46, unit: 'bag' },
    { id: 'proflow_mvs', name: 'ProFlow MVS', type: 'Latex DPM', price: 25.99, unit: 'bag' }
  ],
  primers: [
    { id: 'one_coat_dpm', name: 'One Coat DPM', size: '7kg', price: 116.41, unit: 'tub' },
    { id: 'prime_and_grip', name: 'Prime and Grip', size: '5 Litre', price: 28.34, unit: 'tub' },
    { id: 'prime_plus', name: 'Prime Plus', size: '5 Litre', price: 18.08, unit: 'tub' }
  ]
};

// Step 2: ProEpoxy Primers
export const EPOXY_PRIMERS = {
  '1_part': {
    name: '1 Part Rapid Cure (P300) Acrylic Primer',
    colors: ['White', 'Grey'],
    packs: [
      { size: 5, price: 22.49 },
      { size: 20, price: 50.49 },
      { size: 40, price: 94.99 }
    ]
  },
  '2_part': {
    name: '2 Part DPM Epoxy Primer',
    colors: ['White', 'Grey', 'Black'],
    packs: [
      { size: 5, price: 34.99 },
      { size: 20, price: 74.99 },
      { size: 40, price: 144.99 }
    ]
  }
};

// Step 3: Design Coat Products
export const DESIGN_COAT_PRODUCTS = {
  comfort: {
    id: 'comfort',
    name: "Designer 'Comfort' Epoxy",
    description: '12kg unit · covers 10m²',
    packs: [
      { size: 10, kg: 12, price: 165.30 }
    ]
  },
  crystal: {
    id: 'crystal',
    name: "Rock Hard 'Crystal' Epoxy",
    description: '7.5kg unit - covers approx 5-7m² per unit',
    unitSize: 7.5,
    coverageMin: 5,
    coverageMax: 7,
    price: 99.00
  }
};

// Step 4: Pigments, Glitters and Sprays
export const PIGMENTS_PRODUCTS = {
  metallicPowder: {
    name: 'Metallic Pigment Powders',
    sizes: [
      { size: '100g', price: 8.99 },
      { size: '1kg', price: 74.99 }
    ],
    colors: ['Gold', 'Bronze', 'Copper', 'Russet', 'Yellow', 'Silver', 'Grey', 'Pearl', 'Ice White', 'Black', 'Red', 'Blue', 'Green', 'Purple', 'Beige']
  },
  pigmentPaste: {
    name: 'Pigment Paste',
    packs: [
      { size: 5, price: 14.99, description: '400g' },
      { size: 20, price: 34.99, description: '4×400g' },
      { size: 40, price: 74.99, description: '8×400g' }
    ],
    colors: ['Black', 'White']
  },
  glitter: {
    types: ['Disco Glitter', 'Diamond Glitter'],
    packs: [
      { size: 5, price: 10.99 },
      { size: 20, price: 35.99 },
      { size: 40, price: 64.99 }
    ]
  },
  sprays: {
    marbleSpray: {
      name: 'Marble Spray',
      price: 8.95,
      unit: '400ml',
      colors: ['Black', 'White', 'Silver', 'Copper', 'Gold', 'Pastel Green', 'Blue', 'Grey', 'Red', 'Yellow']
    },
    metallicSpray: {
      name: 'Metallic Spray',
      price: 8.95,
      unit: '400ml',
      colors: ['Bright Copper', 'Chrome', 'Gold']
    }
  }
};

// Step 5: Protective Top Coats
export const TOP_COAT_PRODUCTS = {
  polyurethane: {
    name: 'Polyurethane',
    finishes: ['Gloss', 'Satin', 'Matt'],
    packs: [
      { size: 5, price: 29.99 },
      { size: 20, price: 89.99 },
      { size: 40, price: 170.99 }
    ]
  },
  polyaspartic: {
    name: 'Polyaspartic',
    finishes: ['Gloss'],
    packs: [
      { size: 5, price: 34.99 }
    ]
  }
};

// ============= HIGH BUILD EPOXY SYSTEM PRODUCTS =============

// High Build Epoxy Paint
export const HIGH_BUILD_EPOXY = {
  name: 'High Build Epoxy',
  packs: [
    { size: 5, weight: '5kg', coverage: '15-20m²', coverageMax: 20, price: 64.99 },
    { size: 25, weight: '25kg', coverage: '75-100m²', coverageMax: 100, price: 299.99 }
  ],
  colors: [
    { code: 'RAL #3013', name: 'Tomato Red', hex: '#a63d3d' },
    { code: 'RAL #3020', name: 'Traffic Red', hex: '#c13832' },
    { code: 'RAL #2002', name: 'Vermilion', hex: '#c75b3b' },
    { code: 'RAL #1004', name: 'Golden Yellow', hex: '#d4a84b' },
    { code: 'RAL #1015', name: 'Light Ivory', hex: '#e8dfc4' },
    { code: 'RAL #6002', name: 'Leaf Green', hex: '#3d6b3d' },
    { code: 'RAL #6025', name: 'Fern Green', hex: '#5b7a4a' },
    { code: 'RAL #5013', name: 'Cobalt Blue', hex: '#1e3a5f' },
    { code: 'RAL #5015', name: 'Sky Blue', hex: '#2271b3' },
    { code: 'RAL #7035', name: 'Light Grey', hex: '#c4c9c7' },
    { code: 'RAL #7001', name: 'Silver Grey', hex: '#8c9291' },
    { code: 'RAL #7015', name: 'Slate Grey', hex: '#51565c' },
    { code: 'RAL #9010', name: 'Pure White', hex: '#f5f3e8' },
    { code: 'RAL #9005', name: 'Jet Black', hex: '#0e0e10' }
  ]
};

// Flakes for Flake Floor
export const FLAKE_PRODUCTS = {
  packs: [
    { size: 1, weight: '1kg', price: 14.99, coverageFull: 2, coveragePartial: 6.67, limitedColors: true },
    { size: 10, weight: '10kg', price: 129.99, coverageFull: 20, coveragePartial: 66.7, limitedColors: true },
    { size: 20, weight: '20kg', price: 241.60, coverageFull: 40, coveragePartial: 133.3, limitedColors: false }
  ],
  limitedColors: [
    { name: 'Domino', type: 'blended' },
    { name: 'Glacier Peak', type: 'blended' },
    { name: 'Quicksilver', type: 'blended' },
    { name: 'Sailor Sky', type: 'blended' }
  ],
  allColors: [
    { name: 'Comet', type: 'blended' },
    { name: 'Coral', type: 'blended' },
    { name: 'Creekbed', type: 'blended' },
    { name: 'Daffodil', type: 'blended' },
    { name: 'Domino', type: 'blended' },
    { name: 'Glacier Peak', type: 'blended' },
    { name: 'Quicksilver', type: 'blended' },
    { name: 'Sailor Sky', type: 'blended' },
    { name: 'Spearmint', type: 'blended' },
    { name: 'Glacier', type: 'blended' },
    { name: 'Keystone', type: 'blended' },
    { name: 'Mushroom', type: 'blended' },
    { name: 'Nightfall', type: 'blended' },
    { name: 'Riveira', type: 'blended' },
    { name: 'Salmon', type: 'blended' },
    { name: 'Shoreline', type: 'blended' },
    { name: 'Smokescreen', type: 'blended' },
    { name: 'Speckled Egg', type: 'blended' },
    { name: 'Oasis', type: 'blended' },
    { name: 'Sailor', type: 'blended' }
  ],
  fullScatterRate: 0.5,
  partialScatterRate: 0.15
};

// Polyaspartic for Flake Floor seal coat
export const POLYASPARTIC_SEAL = {
  name: 'Polyaspartic Seal Coat',
  packs: [
    { size: 5, price: 34.99 },
    { size: 20, price: 99.99 }
  ]
};

// High Build System Types
export const HIGH_BUILD_SYSTEMS = {
  best: {
    id: 'best',
    name: 'High Build - Best',
    description: '1 x Epoxy Prime Coat + 2 x High Build Epoxy Coats',
    primerCoats: 1,
    highBuildCoats: 2,
    hasFlakes: false
  },
  standard: {
    id: 'standard',
    name: 'High Build - Standard',
    description: '1 x Epoxy Prime Coat + 1 x High Build Epoxy Coat',
    primerCoats: 1,
    highBuildCoats: 1,
    hasFlakes: false
  },
  flakeFloor: {
    id: 'flakeFloor',
    name: 'Flake Floor',
    description: '1 x Epoxy Prime + 1 x High Build (scatter flakes) + 1 x Polyaspartic',
    primerCoats: 1,
    highBuildCoats: 1,
    hasFlakes: true
  }
};

// Flake coverage rates (kg per m²)
export const FLAKE_COVERAGE = {
  fullScatter: 0.5,
  partialScatter: 0.15
};

// Colour chart image URL
export const HIGH_BUILD_COLOUR_CHART = 'https://customer-assets.emergentagent.com/job_a815a64e-1f88-45c4-8eea-9a9f9487d5d7/artifacts/j5uzque1_IMG_8301.jpeg';
